import React, {useEffect, useRef, useState} from 'react';
import API from '../utils/api';

const box={background:'#fff',borderRadius:16,padding:15,marginBottom:13};
const field={padding:9,border:'1px solid #ccd5df',borderRadius:7,maxWidth:'100%',boxSizing:'border-box'};
const button={...field,background:'#edf5ff',color:'#174b86',cursor:'pointer'};
function chinaDay(delta=0){return new Date(Date.now()+8*3600000+delta*86400000).toISOString().slice(0,10);}
const errors={'query-timeout':'现场网关未及时完成查询，请检查只读程序是否运行。','device-query-failed':'设备查询失败，可能不支持此查询或登录失败。','helper-query-failed':'设备查询未成功，请检查设备支持情况和只读程序。','helper-timeout':'设备查询超时，请稍后重试。'};
export default function HikReadOnly(){
  const [deviceCode,setDeviceCode]=useState('HIK-EAST-GATE');
  const [kind,setKind]=useState('people'),[employee,setEmployee]=useState('');
  const [start,setStart]=useState(chinaDay()+'T00:00'),[end,setEnd]=useState(chinaDay()+'T23:59');
  const [result,setResult]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState('');
  const [name,setName]=useState(''),[detail,setDetail]=useState(null),[history,setHistory]=useState([]);
  const current=useRef(null),generation=useRef(0),timer=useRef(null);
  useEffect(()=>()=>{generation.current++;clearTimeout(timer.current);},[]);
  function reset(){generation.current++;clearTimeout(timer.current);setBusy(false);setResult(null);setError('');setDetail(null);setHistory([]);current.current=null;}
  async function run(query,stack){
    const id=++generation.current;clearTimeout(timer.current);setBusy(true);setError('');setResult(null);setDetail(null);
    const fail=e=>{if(id!==generation.current)return;setBusy(false);setError(e.response?.data?.message||e.message||'查询失败');};
    try{
      const r=await API.post('/access-admin/hik-readonly/query',query);
      if(id!==generation.current)return;
      const q={...query,searchID:r.data.searchID};current.current=q;setHistory(stack);
      const deadline=Date.now()+125000;
      const poll=async()=>{
        if(id!==generation.current)return;
        try{
          const r=await API.get('/access-admin/hik-readonly/query/'+encodeURIComponent(rid));
          if(id!==generation.current)return;
          if(r.data.status==='success'){setResult(r.data.result);setBusy(false);return;}
          if(r.data.status==='failed')throw Error(errors[r.data.error]||'设备查询失败：'+(r.data.error||'未知错误'));
          if(Date.now()>deadline)throw Error('等待网关超时，请确认现场只读程序已启动。');
          timer.current=setTimeout(poll,2000);
        }catch(e){fail(e);}
      };
      const rid=r.data.query_uuid;await poll();
    }catch(e){fail(e);}
  }
  const query=()=>{
    const q={kind,deviceCode,employeeNo:employee.trim(),position:0};
    if(kind==='events'){q.startTime=start+':00+08:00';q.endTime=end+':59+08:00';}
    run(q,[]);
  };
  const rows=(result?.rows||[]).filter(r=>!name||String(r.name||'').includes(name));
  return <section style={box}>
    <h3 style={{marginTop:0}}>海康门禁查询</h3>
    <p style={{fontSize:13,color:'#666'}}>读取设备实际人员及历史事件。查询不会下发、修改或删除人脸。人员每页最多20条，通行记录每页最多5条。</p>
    <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
      <button style={button} onClick={()=>{reset();setKind('people');}}>海康主机人员</button>
      <button style={button} onClick={()=>{reset();setKind('events');}}>通行记录</button>
    </div>
    <label>设备 <select style={field} value={deviceCode} onChange={e=>{reset();setName('');setDeviceCode(e.target.value);}}><option value="HIK-EAST-GATE">东大门</option><option value="HIK-WEST-GATE">西大门</option></select></label>
    <h4>{kind==='people'?'海康主机人员':'通行记录'}</h4>
    <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
      <label>人员编号（精确） <input style={field} value={employee} maxLength={32} onChange={e=>{reset();setEmployee(e.target.value);}} placeholder="例如 301 或 HIK000301" /></label>
      {kind==='events'&&<>
        <label>开始（北京时间） <input type="datetime-local" style={field} value={start} onChange={e=>{reset();setStart(e.target.value);}} /></label>
        <label>结束（北京时间） <input type="datetime-local" style={field} value={end} onChange={e=>{reset();setEnd(e.target.value);}} /></label>
        {[['今天',0],['昨天',-1],['最近7天',-6]].map(([label,d])=><button key={label} style={button} onClick={()=>{reset();setStart(chinaDay(d)+'T00:00');setEnd(chinaDay(label==='昨天'?-1:0)+'T23:59');}}>{label}</button>)}
      </>}
      <button style={button} disabled={busy} onClick={query}>{busy?'正在等待设备…':'查询设备'}</button>
    </div>
    {error&&<p role="alert" style={{color:'#b42318'}}>{error}</p>}
    {result&&<>
      <p style={{fontSize:13}}>设备：{result.deviceCode==='HIK-WEST-GATE'?'西大门':'东大门'} · 设备报告总数：{result.total} · 查询时间：{new Date(result.queriedAt).toLocaleString('zh-CN',{timeZone:'Asia/Shanghai',hour12:false})}（北京时间）</p>
      <label>本页姓名筛选 <input style={field} value={name} onChange={e=>setName(e.target.value)} placeholder="仅筛选已读取的这一页" /></label>
      <div style={{overflowX:'auto',marginTop:12}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}><thead><tr>{(kind==='people'?['姓名','人员编号','类型','人脸数量','详情']:['时间','姓名','人员编号','门号','验证方式（设备原值）','事件码','详情']).map(h=><th key={h} style={{padding:8,textAlign:'left',whiteSpace:'nowrap'}}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((r,i)=><tr key={i} style={{borderTop:'1px solid #eee'}}>
          {(kind==='people'?[r.name,r.employeeNo,r.userType,r.numOfFace]:[r.time,r.name,r.employeeNoString,r.doorNo,r.currentVerifyMode,`${r.major??'—'}/${r.minor??'—'}`]).map((v,j)=><td key={j} style={{padding:8,wordBreak:'break-word'}}>{v===undefined||v===null?'—':String(v)}</td>)}
          <td><button style={button} onClick={()=>setDetail(r)}>查看</button></td>
        </tr>)}</tbody></table>
      </div>
      {!rows.length&&<p>{name?'本页没有匹配姓名。':'设备本次未返回记录。'}</p>}
      {kind==='events'&&<p style={{color:'#666',fontSize:12}}>事件可能包含认证失败和其他门禁事件。保留设备原始主/次事件码；尚未确认的事件不会标记为“通行成功”。</p>}
      <div style={{display:'flex',gap:10}}>
        <button style={button} disabled={busy||!history.length} onClick={()=>run({...current.current,position:history[history.length-1]},history.slice(0,-1))}>上一页</button>
        <button style={button} disabled={busy||!result.more} onClick={()=>run({...current.current,position:result.nextPosition},[...history,current.current.position])}>下一页</button>
      </div>
    </>}
    {detail&&<div style={{marginTop:12,border:'1px solid #ccd5df',padding:12,borderRadius:8}}><b>设备返回详情</b><button style={{...button,float:'right'}} onClick={()=>setDetail(null)}>关闭</button><pre style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{JSON.stringify(detail,null,2)}</pre></div>}
  </section>;
}
